import { HomeIcon } from "@heroicons/react/20/solid";
import classNames from "classnames";
import { Link } from "react-router-dom";

const defaultRootPage = {
  href: '/',
  Icon: HomeIcon,
  screenReaderText: 'Home'
} 
export default function Breadcrumb({className = "", pages, rootPage = defaultRootPage }) {
  const Icon = rootPage.Icon

  return (
    <nav className={classNames("bg-white p-2 rounded-lg flex", className)} aria-label="Breadcrumb">
      <ol role="list" className="flex items-center space-x-4">
        <li>
          <div>
            <Link to={rootPage.href} className="text-gray-400 hover:text-gray-500">
              <Icon className="h-5 w-5 flex-shrink-0" aria-hidden="true" />
              <span className="sr-only">{rootPage.screenReaderText}</span>
            </Link>
          </div>
        </li>
        {pages.map((page) => (
          <li key={page.name}>
            <div className="flex items-center">
              <svg
                className="h-5 w-5 flex-shrink-0 text-gray-300"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 20 20"
                aria-hidden="true"
              >
                <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
              </svg>
              <Link
                to={page.href}
                className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                aria-current={page.current ? "page" : undefined}
              >
                {page.name}
              </Link>
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
}
